import { gql } from "@apollo/client";

export const GET_AUTH_FLOW = gql`
  query GetAuthFlow($caseId: ID!) {
    authFlow(caseId: $caseId) {
      authFlow
    }
  }
`;
